import React from 'react';
import type { FC } from 'react';
import { SiteAuthProvider } from '@wix/cli-auth';
import { CliError, CliErrorCode } from '@wix/cli-error';
import { useAsync } from '@wix/cli-ui-kit';
import { match } from 'variant';
import { useProjectModel } from '../../model.js';
import { TranslationPull } from './TranslationPull.js';

export const TranslationPullCommand: FC<{ onComplete?: () => void }> = ({
  onComplete,
}) => {
  const {
    model: { config },
  } = useProjectModel();

  const { status } = useAsync(async () => {
    if (config.projectType !== 'Site') {
      throw new CliError({
        code: CliErrorCode.TranslationUnsupportedForProjectType(),
        cause: null,
      });
    }
    return { siteId: config.siteId };
  }, []);

  return match(status, {
    Loading: () => null,
    Error: () => null,
    Success: ({ result: { siteId } }) => {
      return (
        <SiteAuthProvider siteId={siteId}>
          <TranslationPull onComplete={onComplete} />
        </SiteAuthProvider>
      );
    },
  });
};
